/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useMutation } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import CustomerAccountDeleteMutation from './__mutation__/index.customerAccount.delete.mutation'
import CustomerAccountDeleteAllMutation from './__mutation__/index.customerAccount.deleteall.mutation'

/*
 * OBJECTS
 */
const Index = ({ passOn, onClose, refetch }) => {
  // Hook assignment.
  const [MutationCustomerAccountDelete, MutationCustomerAccountDeleteResponse] = useMutation(CustomerAccountDeleteMutation)
  const [MutationCustomerAccountDeleteAll, MutationCustomerAccountDeleteAllResponse] = useMutation(CustomerAccountDeleteAllMutation)

  // Return Component.
  return (

    <DeleteCard
      onClose={onClose}
      disabled={MutationCustomerAccountDeleteResponse.loading || MutationCustomerAccountDeleteAllResponse.loading}
      onConfirm={() => {
        if (passOn?.isMulti) {
          // Parent delete - use customerAccountDeleteAll API
          return MutationCustomerAccountDeleteAll({
            'variables': {
              'customerAccountIds': passOn?.customerAccountIds
            }
          }).then(i => {
            toast(i?.data?.CustomerAccountDeleteAll?.message || 'Parent account deleted successfully')
            refetch?.()
            return onClose?.()
          }).catch(() => toast('Something went wrong please try after some time.'))
        } else {
          // Individual delete 
          return MutationCustomerAccountDelete({
            'variables': {
              'customerAccountId': passOn?.customerAccountId
            }
          }).then(i => {
            toast(i?.data?.CustomerAccountDelete?.message)
            refetch?.()
            return onClose?.()
          }).catch(() => toast('Something went wrong please try after some time.'))
        }
      }}
      isLoading={MutationCustomerAccountDeleteResponse.loading || MutationCustomerAccountDeleteAllResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func,
  'refetch': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
